module.exports = __webpack_public_path__ + "img/webpay.574ba768.png";